import React, { useEffect } from 'react';

const TidyCalEmbed = ({ dataPath }) => {
  useEffect(() => {
    const scriptId = 'tidycal-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://asset-tidycal.b-cdn.net/js/embed.js';
      script.async = true;
      document.body.appendChild(script);
    } else {
      // Re-initialize if script already loaded
      if (window.TidyCal) window.TidyCal.init?.();
    }
  }, [dataPath]);

  return (
    <div className="my-6 w-full">
      <div className="tidycal-embed" data-path={dataPath} />
    </div>
  );
};

export default TidyCalEmbed;